import { render, staticRenderFns } from "./certifiForm.vue?vue&type=template&id=72c6257a&scoped=true&"
import script from "./certifiForm.vue?vue&type=script&lang=js&"
export * from "./certifiForm.vue?vue&type=script&lang=js&"
import style0 from "./certifiForm.vue?vue&type=style&index=0&id=72c6257a&prod&lang=less&"
import style1 from "./certifiForm.vue?vue&type=style&index=1&id=72c6257a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c6257a",
  null
  
)

export default component.exports